<template>
  <section class="reviews">
    <div class="container">
      <h5>Hodnotenia zákazníkov</h5>
      <div class="row">
        <div class="col-lg-12 column">
          <span class="total">{{ average }}</span>
          <Stars :stars="0" />
          <p class="customer-count">Celkový počet hodnotení: {{ total }}</p>
          <ListStars :group="groupedRatings" />
        </div>

        <div class="col-lg-12 column">
          <button
            type="button"
            class="button secondary icon"
            @click="handleModal"
          >
            Pridať
          </button>
        </div>

        <div class="col-lg-12 column">
          <ul class="list-reset list-reviews">
            <p v-if="total <= 0">Zatiaľ neboli pridané žiadne recenzie.</p>
            <ReviewItem v-for="item in items" :key="item.id" :rating="item" />
          </ul>
        </div>
        <div class="col-lg-12 column">
          <span
            class="show-more"
            v-if="btnMoreVisible && total > 0"
            @click="showMore"
          >
            Zobraziť viac
          </span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { inject, onMounted, reactive, toRefs } from "vue";

import Stars from "./Stars";
import ListStars from "./ListStars";
import ReviewItem from "./ReviewItem";
import axios from "axios";

export default {
  props: ["productId"],

  components: {
    ReviewItem,
    ListStars,
    Stars,
  },

  setup(props) {
    const state = reactive({
      btnMoreVisible: true,
      items: [],
      total: 0,
      average: 0,
      groupedRatings: "",
      visible: 0,
    });

    const emitter = inject("emitter");

    onMounted(() => {
      setTimeout(() => getReviews(state.visible), 250);
    });

    function getReviews(start) {
      axios
        .post(`/produkt/hodnotenia`, { id: props.productId, start: start })
        .then((response) => {
          if (response.data.items)
            state.items = state.items.concat(response.data.items);
          if (response.data.total) state.total = response.data.total;
          if (response.data.average) state.average = response.data.average;
          if (response.data.grouped_ratings)
            state.groupedRatings = response.data.grouped_ratings;
          if (state.items.length >= state.total) state.btnMoreVisible = false;
        })
        .catch((error) => console.error(error));
    }

    function handleModal() {
      emitter.emit("show-review-modal");
    }

    function showAll() {
      state.btnAllVisible = false;

      document.querySelectorAll(".js-review-item").forEach((item, index) => {
        if (item.classList.contains("hidden")) item.classList.remove("hidden");
      });
    }

    function showMore() {
      const visible = document.querySelectorAll(".js-review-item").length;
      getReviews(visible);
    }

    return {
      ...toRefs(state),
      handleModal,
      showAll,
      showMore,
    };
  },
};
</script>
